import { Col, ColumnConfig, Section, SectionHeading, TableMobile, TableRowData } from "@/components";
import { SectionLink } from "@anoki/fse-common";
import { TypographyKeys } from "@theme/typography.ts";
import clsx from "clsx";
import { ComponentType, PropsWithChildren, ReactNode } from "react";
import { RichText } from "../RichText";
import { TableAlignment } from "../TableList";
import "./TableMobileList.scss";

type TableMobileListProps = PropsWithChildren<{
  title?: ReactNode;
  description?: ReactNode;
  tableJson?: {
    columns: ColumnConfig[];
    rows: TableRowData[];
  };
  links?: SectionLink[];
  asLink?: "a" | ComponentType<any>;
  fontSize?: TypographyKeys;
  mdFontSize?: TypographyKeys;
  classNameTitle?: string;
  additionalClass?: string;
  variantClassTable?: TableAlignment;
  pagination?: boolean;
  resultsPerPage?: number;
  // Sorting props
  sortConfig?: { key: string; direction: "asc" | "desc" } | null;
  onSortChange?: (key: string, direction: "asc" | "desc") => void;
  // Server pagination props
  totalResults?: number;
  initialCurrentPage?: number;
  serverSidePagination?: boolean;
  totalItems?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  onPageChange?: (page: number) => void;
  setCurrentPage?: (page: number) => void;
}>;

export const TableMobileList = ({
  title,
  description,
  tableJson,
  fontSize = "2",
  mdFontSize = "2",
  classNameTitle,
  additionalClass,
  variantClassTable = TableAlignment.LEFT,
  pagination = true,
  resultsPerPage = 5,
  sortConfig,
  onSortChange,
  totalResults,
  initialCurrentPage,
  serverSidePagination,
  totalItems,
  hasNextPage,
  hasPreviousPage,
  onNextPage,
  onPreviousPage,
  onPageChange,
  setCurrentPage,
  children,
}: TableMobileListProps) => {
  return (
    <Section
      className={clsx("base-col ui-table-mobile-list-section", additionalClass)}
    >
      <Col className="ui-table-mobile-list-content">
        <SectionHeading
          title={title}
          fs={fontSize}
          mdFs={mdFontSize}
          className={classNameTitle}
          descriptionClassName={clsx("text-slate-28", variantClassTable)}
          color={"blue-48"}
          description={
            description
              ? <RichText description={description}></RichText>
              : undefined
          }
          descriptionMarginBottom="0"
          titleMarginBottom="0"
        />
        {tableJson && tableJson.columns && tableJson.rows && (
          <TableMobile
            data={tableJson.rows}
            columns={tableJson.columns}
            pagination={pagination}
            resultsPerPage={resultsPerPage}
            sortConfig={sortConfig}
            onSortChange={onSortChange}
            totalResults={totalResults}
            initialCurrentPage={initialCurrentPage}
            serverSidePagination={serverSidePagination}
            totalItems={totalItems}
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            onPageChange={onPageChange}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Col>
      {children}
    </Section>
  );
};
